// 「這一輪沒有回覆」的串流旁路（#1473）。事件流那一筆重整後看得到，
// 但即時畫面沒有它就仍然是一則空訊息掛在那裡等 30 秒。
//
// 走 transient data part，與工具耗時同一套：transient 的不進 message.parts，
// 歷史重建那條路徑完全不受影響，前端只在 onData 收下。
// 🔴 伺服器與前端共用這一支，型別字串只有一份，兩邊不會漂移。

/** data part 的型別字串。AI SDK 規定 data part 一律以 data- 起頭。 */
export const TURN_NO_OUTPUT_DATA_TYPE = 'data-turn-no-output'

/** 這一輪沒有可見產出。沒有欄位：型別本身就是全部的資訊。 */
export const turnNoOutputChunk = () => ({
  type: TURN_NO_OUTPUT_DATA_TYPE,
  data: {},
  transient: true,
})

/**
 * 從 onData 收到的東西裡認出這一筆。同一個 callback 會收到所有 data part，
 * 不篩就會把別人的資料當成「沒有回覆」。
 */
export const isTurnNoOutputData = (chunk: unknown): boolean =>
  (chunk as { type?: unknown } | null)?.type === TURN_NO_OUTPUT_DATA_TYPE
